export default {
  SEARCH_BOX_CLASS: 'search search-modal__form search-bar',
};
